import { useEffect, useState } from 'react';
import { apiFetch } from '../network';

export function useAnalyticsDashboard(days = 30) {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const refreshDashboard = async () => {
    setLoading(true);
    setError(false);

    try {
      const response = await apiFetch(`/analytics/dashboard?days=${days}`);

      if (!response.ok) {
        throw new Error('request_failed');
      }

      const payload = await response.json();
      setDashboard(payload.dashboard || null);
    } catch (requestError) {
      setDashboard(null);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshDashboard();
  }, [days]);

  return {
    dashboard,
    loading,
    error,
    refreshDashboard
  };
}
